import React from 'react'
import './Analytics.scss';

function Analytics() {
    return (
        <div id='analytics'>
            <div className='fadeSlider'></div>
            <div className='row analyticGroup flex-nowrap'>
                <div className='col customWidth'>
                    <div className='dataGroup'>
                        <h3>Sports Covered</h3>
                        <h4>6+</h4>
                    </div>
                </div>
                <div className='col customWidth'>
                    <div className='dataGroup'>
                        <h3>Satisfied Members</h3>
                        <h4>100+</h4>
                    </div>
                </div>
                <div className='col customWidth'>
                    <div className='col dataGroup'>
                        <h3>Estimated Profit</h3>
                        <h4>$20,000</h4>
                    </div>
                </div>
                <div className='col customWidth'>
                    <div className='dataGroup'>
                        <h3>Combined Experience</h3>
                        <h4>50 Years</h4>
                    </div>
                </div>
                <div className='col customWidth'>
                    <div className='dataGroup'>
                        <h3>Successful Picks</h3>
                        <h4>1500+</h4>
                    </div>
                </div>
                <div className='col customWidth'>
                    <div className='dataGroup'>
                        <h3>Sports Covered</h3>
                        <h4>6+</h4>
                    </div>
                </div>
                <div className='col customWidth'>
                    <div className='dataGroup'>
                        <h3>Satisfied Members</h3>
                        <h4>100+</h4>
                    </div>
                </div>
                <div className='col customWidth'>
                    <div className='col dataGroup'>
                        <h3>Estimated Profit</h3>
                        <h4>$20,000</h4>
                    </div>
                </div>
                <div className='col customWidth'>
                    <div className='dataGroup'>
                        <h3>Combined Experience</h3>
                        <h4>50 Years</h4>
                    </div>
                </div>
                <div className='col customWidth'>
                    <div className='dataGroup'>
                        <h3>Successful Picks</h3>
                        <h4>1500+</h4>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Analytics
